<!-- Hex literals throughout are quoted from the canvas export; none has a matching public token. -->
<div
  *transloco="let t; prefix: scope"
  class="flex w-full flex-col overflow-hidden rounded-t-2xl border border-[#dde4ee] bg-white shadow-[0_1.375rem_3.25rem_rgba(16,24,40,0.18)] md:mr-6 md:mb-6 md:ml-auto md:w-[23.625rem] md:rounded-2xl"
  data-id="consultation-offer"
>
  <div class="flex items-center gap-[0.6875rem] border-b border-[#dce7fa] bg-[#edf3ff] px-5 pt-4 pb-[0.9375rem]">
    <img alt="RateMyAgent" class="flex-none" [src]="logoPath | staticImageUrl" width="32" height="36" />
    <span class="flex-1 text-[0.8125rem] leading-[1.4] font-semibold text-[#00255c]" data-id="consultation-offer-header">{{
      t('header')
    }}</span>
    <button
      type="button"
      class="-mr-2 flex-none p-2 text-[0.9375rem] leading-none text-[#7a8ca6] hover:text-[#00255c]"
      [attr.aria-label]="t('close')"
      (click)="dismissed.emit()"
      data-id="consultation-offer-close"
    >
      <span aria-hidden="true">✕</span>
    </button>
  </div>

  <div class="flex flex-col gap-3.5 px-5 pt-[1.125rem] pb-5">
    <h2
      class="text-[1.3125rem] leading-[1.22] font-semibold tracking-[-0.016em] text-pretty text-steel-100"
      data-id="consultation-offer-heading"
    >
      {{ t('heading') }}
    </h2>

    <p class="text-[0.84375rem] leading-[1.55] text-steel-90" data-id="consultation-offer-body">{{ t('body') }}</p>

    <ul class="flex flex-col gap-[0.5625rem] rounded-[0.6875rem] bg-[#f7f9fc] px-3.5 py-[0.8125rem]">
      @for (tick of tickKeys; track tick) {
        <li class="flex items-start gap-[0.5625rem]">
          <!-- Height matches the adjacent line box so the glyph centres on the first line of its row. -->
          <rma-icon class="h-[1.21875rem] flex-none items-center text-[#0f8a5f]" glyph="check" size="extraSmall" />
          <span class="text-[0.8125rem] leading-[1.5] text-steel-90" [attr.data-id]="'consultation-offer-' + tick">{{ t(tick) }}</span>
        </li>
      }
    </ul>

    <!-- innerHTML because the count is bold inside the sentence, and splitting it would hand
         translators two fragments they cannot reorder. -->
    <p
      class="text-[0.78125rem] leading-[1.45] text-steel-90 [&_strong]:font-semibold"
      [innerHTML]="t('stat')"
      data-id="consultation-offer-stat"
    ></p>

    <!-- A plain href, not routerLink: the finder is a separately deployed app and a Router hop 404s
         against the public route table. -->
    <a
      class="bg-renowned-purple flex h-12.5 w-full items-center justify-center gap-2 rounded-[0.6875rem] text-[0.96875rem] font-semibold! text-white! no-underline! shadow-[0_0.375rem_1.125rem_rgba(104,60,238,0.3)]"
      [href]="finderUrl()"
      (click)="accepted.emit()"
      data-id="consultation-offer-cta"
    >
      <span data-id="consultation-offer-cta-label">{{ t('cta') }}</span>
      <span aria-hidden="true" class="text-[1rem] leading-none">→</span>
    </a>

    <button
      type="button"
      class="self-center text-[0.8125rem] font-medium text-steel-70 underline"
      (click)="dismissed.emit()"
      data-id="consultation-offer-dismiss"
    >
      {{ t('dismiss') }}
    </button>
  </div>
</div>
